import { useReactiveVar } from '@apollo/client';
import React, { FC, useState } from 'react';
import useCheckLocalStorageSupport from '../../hooks/useCheckLocalStorageSupport';
import { vars } from '../../reactive';
import BranchForm from '../../views/Branches/BranchForm/BranchForm';
import ProviderForm from '../../views/Providers/ProviderForm/ProviderForm';
import BranchFormFill from '../../views/Branches/BranchFormFill/BranchFormFill';

const MainForm: FC<{
  authLoading: boolean;
  branch: Record<string, unknown>;
  provider?: Record<string, unknown>;
  isFormFill?: boolean;
}> = ({ authLoading, branch, provider, isFormFill }) => {
  const isLocalStorageSupported = useCheckLocalStorageSupport();

  if (isFormFill && branch) {
    return <BranchFormFill branch={branch} authLoading={authLoading} isLocalStorageSupported={isLocalStorageSupported} />;
  }

  return (
    <>
      {provider && !branch ? (
        <ProviderForm authLoading={authLoading} provider={provider} isLocalStorageSupported={isLocalStorageSupported} />
      ) : (
        <BranchForm authLoading={authLoading} branch={branch} isLocalStorageSupported={isLocalStorageSupported} />
      )}
    </>
  );
};

export default MainForm;
